import { render, staticRenderFns } from "./modifyAvatar.vue?vue&type=template&id=034bee8e&scoped=true"
import script from "./modifyAvatar.vue?vue&type=script&lang=js"
export * from "./modifyAvatar.vue?vue&type=script&lang=js"
import style0 from "./modifyAvatar.vue?vue&type=style&index=0&id=034bee8e&prod&lang=scss&scoped=true"
import style1 from "./modifyAvatar.vue?vue&type=style&index=1&id=034bee8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bee8e",
  null
  
)

export default component.exports